export const config = {
    BASE_URL : 'https://api.pier10.app',
    STRIPE_PUBLIC: 'pk_live_51Jy2GPInZLKYKBuQ6AF2VdAVW5IbEsPo3c60JPYuokZKp5O5Bnguib1brjhp7S1OcMCp0F2FVOheby9W3nuguy1500ugrYdWCr',
    MAPS_KEY: "AIzaSyBEDmMpSAz_XFh_03IvCH9aY91OgbUIeew"
}
